import { PlatformSettingsFormShell } from '@app/modules/social-export/components/settings/PlatformSettingsFormShell';
import { BaseSettingsFormProps } from '@app/modules/social-export/hooks/social-export-form-props';
import { socialExport } from '@mi-front/api-clients';
import { Grid } from '@mui/material';
import { SelectElement } from 'react-hook-form-mui';
import { defineMessage, defineMessages, useIntl } from 'react-intl';
import { z } from 'zod';

export const twitterSettingsSchema = z.object({
  replySettings: z
    .nativeEnum(socialExport.TwitterSettingsDtoReplySettingsEnum)
    .nullable()
    .optional(),
});

const replySettingsMessages = defineMessages({
  everyone: {
    id: 'socialExport.twitter.replyEveryone',
    defaultMessage: 'Todos',
  },
  following: {
    id: 'socialExport.twitter.replyFollowing',
    defaultMessage: 'Personas que sigues',
  },
  mentionedUsers: {
    id: 'socialExport.twitter.replyMentioned',
    defaultMessage: 'Usuarios mencionados',
  },
  subscribers: {
    id: 'socialExport.twitter.replySubscribers',
    defaultMessage: 'Suscriptores',
  },
  verified: {
    id: 'socialExport.twitter.replyVerified',
    defaultMessage: 'Verificados',
  },
});

const replyConfigMessage = defineMessage({
  id: 'socialExport.form.replyConfig',
  defaultMessage: 'Configuración de respuestas',
});

export function TwitterSettingsForm({
  onUpdate,
  defaultSettings,
}: BaseSettingsFormProps<socialExport.TwitterSettingsDto>) {
  const { $t, formatMessage } = useIntl();
  const replySettingsOptions = Object.values(socialExport.TwitterSettingsDtoReplySettingsEnum).map(
    (value: socialExport.TwitterSettingsDtoReplySettingsEnumKey) => ({
      id: value,
      label: formatMessage(replySettingsMessages[value as keyof typeof replySettingsMessages]),
    }),
  );

  return (
    <PlatformSettingsFormShell
      values={{
        replySettings: defaultSettings.replySettings,
      }}
      schema={twitterSettingsSchema}
      onSuccess={async (formData) => {
        await onUpdate({
          replySettings: formData.replySettings,
        });
      }}
    >
      <Grid container>
        <Grid item md={3}>
          <SelectElement
            name="replySettings"
            label={$t(replyConfigMessage)}
            options={replySettingsOptions}
            fullWidth
          />
        </Grid>
      </Grid>
    </PlatformSettingsFormShell>
  );
}
